<template>
  <section class="network-section" aria-labelledby="network-title">
    <div class="network-inner">

      <h2 id="network-title" class="section-title">Network di preparatori</h2>

      <!-- Parte 1: immagine + paragrafo + box bordo -->
      <div class="part-1">
        <div class="part-1-image-wrapper">
          <img
            class="part-1-image"
            src="/images/back-view-athletic-woman-outdoors-by-beach-stretching.webp"
            alt=""
            aria-hidden="true"
          />
        </div>
        <div class="part-1-right">
          <p class="paragraph">I preparatori atletici del nostro network condividono lo stesso metodo evidence-based e sono formati per lavorare secondo il protocollo Sportemocracy. Ma il network è anche una community attiva: i nostri preparatori si confrontano, condividono esperienze e si aggiornano costantemente attraverso risorse, workshop e momenti di formazione continua. Tutti i nostri preparatori hanno a cuore il rapporto umano e sono attenti all’aspetto psicologico-emotivo. Questo garantisce che ogni intervento sia allineato alle evidenze più recenti, alla realtà del campo e nel rispetto dell’unicità di ogni atleta.</p>
          <div class="part-2">
            <p class="part-2-text">La durata e l’intensità del percorso si adattano al contesto della tua società.</p>
          </div>
        </div>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'NetworkSection'
}
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.network-section {
  background-color: $secondary-cold;
  color: $white;
  width: 100%;
}

.network-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.section-title {
  margin: 0;
  font-size: 2rem;
  font-weight: 700;
  line-height: 1.2;
}

/* ── Parte 1 ── */

.part-1 {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.part-1-image-wrapper {
  width: 100%;
  aspect-ratio: 4 / 3;
  overflow: hidden;
  border-radius: 25px;
}

.part-1-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  display: block;
}

.part-1-right {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.paragraph {
  margin: 0;
  font-size: 1.125rem;
  line-height: 1.7;
}

/* ── Parte 2 ── */

.part-2 {
  border: 1px solid $white;
  border-radius: 25px;
  padding: 32px 24px;
}

.part-2-text {
  margin: 0;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1.7;
  text-align: left;
}

/* ── Tablet & Desktop ── */

@media (min-width: 768px) {
  .network-inner {
    padding: 64px 40px;
  }

  .part-1 {
    flex-direction: row-reverse;
    gap: 48px;
    align-items: stretch;
  }

  .part-1-image-wrapper {
    flex: 1;
    height: auto;
  }

  .part-1-right {
    flex: 1;
    justify-content: center;
  }
}

@media (min-width: 1440px) {
  .network-inner {
    padding: 80px 120px;
  }

  .section-title {
    font-size: 2.4rem;
  }

  .part-2 {
    padding: 40px 48px;
  }
}
</style>
